<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import Cookies from 'js-cookie'
import { COOKIES_TOKEN_KEY, LOCAL_STORAGE_IID_KEY, LOCAL_STORAGE_REDIRECT_URI_KEY } from '@/constants'
import { INTERCOM_COOKIES_CLEARED_KEY } from '@/router/guards/xcom-messenger'
import { i18n } from '@/setup/setup-i18n'
import { clearSessionTracker, getSessionId as saveSessionId } from '@/services/auth/authx-session'
import { useRoute, router } from '../../router'

const { useActions: useUserStoreActions } = createNamespacedHelpers('User')
const { useState: useLoginDomainStoreState } = createNamespacedHelpers('LoginDomain')

export default defineComponent({

  name: 'LogoutPage',

  setup() {

    const { logout } = useUserStoreActions(['logout'])
    const { tenant } = useLoginDomainStoreState(['tenant'])

    const currentRoute = useRoute()

    const getRedirectUri = (): string => {

      const { redirectUri } = currentRoute.value?.query

      const mobileRedirectUri = localStorage.getItem(LOCAL_STORAGE_REDIRECT_URI_KEY)
      const iid = localStorage.getItem(LOCAL_STORAGE_IID_KEY)

      if (typeof redirectUri === 'string') {
        return redirectUri
      }

      const loginRoute = (router as any).matcher.match({
        name: 'LoginPage',
        query: {
          loggedOut: true,
          langCode: i18n.locale,
          ...(iid && mobileRedirectUri ? { redirectUri: mobileRedirectUri } : {}),
        },
      })

      return window.location.origin + loginRoute.fullPath

    }

    const handleLogout = async () => {

      try {

        await logout({
          token: Cookies.get(COOKIES_TOKEN_KEY),
          tenant: tenant.value,
          redirectUri: getRedirectUri(),
        })
        Cookies.remove(COOKIES_TOKEN_KEY)
        clearSessionTracker()
        saveSessionId()
        sessionStorage.removeItem(INTERCOM_COOKIES_CLEARED_KEY)
      } catch {
        router.replace({ name: 'UnknownErrorPage' })
      }

    }

    onMounted(async () => {
      await handleLogout()
    })

    return {
      getRedirectUri,
      handleLogout,
      logout,
    }

  },

})

</script>

<template>
  <div class="logout">
    <sm-loader />
  </div>
</template>

<style lang="scss" scoped>
.logout {
  @apply flex justify-center items-center min-h-screen;
}
</style>
